import { ProxyFooterProps } from '../common/ProxyFooter';
import { generateFooters } from '../../utils/react-utils';
import { Button } from '@athena/forge';
import CommonFooter from '../common/Footer';
import Header from '../common/Header';
import { I18N_MAPPING } from '../../constants';
import { useWidgetContext } from '../context/WidgetContext';
import withEventHelper from '../common/EventHelper';
import { useEventBus } from '../../hooks/useEventBus';
import { useState } from 'react';
import { getOktaWidgetModel } from '../../utils/widget-facade';
import { getLocalizedString } from '../../utils/i18n-utils';

export type FooterProps = Omit<ProxyFooterProps, 'alwaysDisplayBackToSignIn'>;

function Footer({ text, footerLinks, additionalOnClick }: FooterProps) {
  const reactFooters = [];
  const { eventEmitter } = useWidgetContext();

  const [ displayGoBack, setDisplayGoBack ] = useState(false);
  const [ viewToDisplayValue, setViewToDisplayValue ] = useState('enterCode');

  useEventBus({
    eventName: 'display-go-back',
    onEvent: ({ show }: { show: boolean }) => {
      // Record the view we want to go back to when the button is about to be shown,
      // this attribute/previousAttributes() changes to enterCode when user submits the form and gets an error
      // thus, these attributes can't be used on the fly when button is actually clicked
      if (show) {
        const model = getOktaWidgetModel();
        const viewToDisplay = model.get('viewToDisplay');
        setViewToDisplayValue(viewToDisplay);
      }
      setDisplayGoBack(show);
    },
  });

  if (displayGoBack) {
    reactFooters.push(
      <div key="go-back">
        <Button
          variant="tertiary"
          size="small"
          text={I18N_MAPPING.en['oform.back']}
          className="totp-enroll-go-back"
          fullWidth={false}
          onClick={() => {
            const model = getOktaWidgetModel();
            model.set('viewToDisplay', viewToDisplayValue);
            setDisplayGoBack(false);
            eventEmitter.emitEventToComponent({
              componentName: Header.displayName!,
              eventName: 'update-header-title',
              eventPayload: { headerText: getLocalizedString('totp.enroll.step.1.header.text') },
            });
            //Clear all the errors/inputs done in the form so user gets an impression, the form is refreshed
            jQueryCourage('form').trigger('reset');
          }}
        ></Button>
      </div>
    );
  }
  reactFooters.push(
    ...generateFooters({
      footerLinks,
      alwaysDisplayBackToSignIn: false,
      additionalOnClick,
    })
  );
  return <CommonFooter reactFooters={reactFooters} footerText={text}></CommonFooter>;
}

Footer.displayName = 'EnrollManualPushFooter';
const FooterWithEventHelper = withEventHelper(Footer);
export default FooterWithEventHelper;
